import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Stations from './pages/Stations';
import Releves from './pages/Releves';
import Journaux from './pages/Journaux';
import Inventaire from './pages/Inventaire';
import Alertes from './pages/Alertes';
import Users from './pages/Users';
import Reporting from './pages/Reporting';
import Cartographie from './pages/Cartographie';
import Profile from './pages/Profile';
import Comptabilite from './pages/Comptabilite';
import Finances from './pages/Finances';
import Fiscalite from './pages/Fiscalite';
import AuditLogs from './pages/AuditLogs';
import Analytics from './pages/Analytics';
import RH from './pages/RH';
import Depenses from './pages/Depenses';
import Paie from './pages/Paie';
import AdminLayout from './components/AdminLayout';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="stations" element={<Stations />} />
              <Route path="releves" element={<Releves />} />
              <Route path="journaux" element={<Journaux />} />
              <Route path="inventaire" element={<Inventaire />} />
              <Route path="alertes" element={<Alertes />} />
              <Route path="users" element={<Users />} />
              <Route path="reporting" element={<Reporting />} />
              <Route path="cartographie" element={<Cartographie />} />
              <Route path="profile" element={<Profile />} />
              <Route path="comptabilite" element={<Comptabilite />} />
              <Route path="finances" element={<Finances />} />
              <Route path="fiscalite" element={<Fiscalite />} />
              <Route path="audit" element={<AuditLogs />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="rh" element={<RH />} />
              <Route path="depenses" element={<Depenses />} />
              <Route path="paie" element={<Paie />} />
            </Route>
          </Route>
          <Route path="*" element={<Login />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
